export default __webpack_public_path__ + "static/media/bonus-test-result-reward-bg.cf87df59.png";